/* eslint-disable import/first */

const langs = {};

/** English */
import en from "./en.json";
langs["en"] = en;

/** German */
import de from "./de.json";
langs["de"] = de;

/** Spanish */
import es from "./es.json";
langs["es"] = es;

/** French */
import fr from "./fr.json";
langs["fr"] = fr;

/** Indonesian */
import id from "./id.json";
langs["id"] = id;

/** Italian */
import it from "./it.json";
langs["it"] = it;

/** Japanese */
import ja from "./ja.json";
langs["ja"] = ja;

/** Korean */
import ko from "./ko.json";
langs["ko"] = ko;

/** Portuguese Brazil */
import pt from "./pt.json";
langs["pt"] = pt;

/** Russian */
import ru from "./ru.json";
langs["ru"] = ru;

/** TR? */
import tr from "./tr.json";
langs["tr"] = tr;

/** Vietnamese */
import vi from "./vi.json";
langs["vi"] = vi;

/** Simplified Chinese */
import zh_Hans from "./zh-Hans.json";
langs["zh-Hans"] = zh_Hans;

/** Traditional Chinese */
import zh_Hant from "./zh-Hant.json";
langs["zh-Hant"] = zh_Hant;

export default langs;
